import { useEffect, useState } from "react";
import { toast } from "sonner";
import { http, formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

const input = "w-full px-4 py-2.5 rounded-xl bg-white border border-[#E6DEC3] text-sm focus:outline-none focus:border-[#2C4A3E]";

export const ItemEditor = ({ studentId, item, open, setOpen, onSaved, defaultDate }) => {
  const [subjects, setSubjects] = useState([]);
  const [f, setF] = useState({});
  useEffect(() => { http.get("/subjects").then((r) => setSubjects(r.data)); }, []);
  useEffect(() => { if (open) setF(item ? { date: item.date, subject_id: item.subject_id, topic: item.topic, note: item.note || "" } : { date: defaultDate, subject_id: "math", topic: "", note: "" }); }, [open, item, defaultDate]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async (e) => {
    e.preventDefault();
    try {
      const base = `/planner/students/${studentId}/items`;
      if (item) await http.put(`${base}/${item.id}`, f); else await http.post(base, f);
      toast.success(item ? "Assignment updated" : "Assignment added"); setOpen(false); onSaved();
    } catch (err) { toast.error(formatApiError(err)); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="bg-[#FDFBF7]" data-testid="plan-editor-dialog">
        <DialogTitle className="font-display text-2xl text-[#2C4A3E]">{item ? "Edit assignment" : "Add assignment"}</DialogTitle>
        <form onSubmit={save} className="space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <input type="date" required value={f.date || ""} onChange={set("date")} data-testid="plan-editor-date" className={input} />
            <select value={f.subject_id || "math"} onChange={set("subject_id")} data-testid="plan-editor-subject" className={input}>{subjects.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}</select>
          </div>
          <input required minLength={2} placeholder="Topic or assignment" value={f.topic || ""} onChange={set("topic")} data-testid="plan-editor-topic" className={input} />
          <textarea placeholder="Note for your learner (optional)" value={f.note || ""} onChange={set("note")} maxLength={300} data-testid="plan-editor-note" className={`${input} h-20`} />
          <button data-testid="plan-editor-save" className="w-full py-3 rounded-full bg-[#C87D53] text-white">Save</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
